import "./DetailCard.scss";
import { useSearchResults } from "../../context/SearchResultsContext";

const DetailCard = ({ 
  title, 
  value, 
  onClick, 
  isClickable = false, 
  isActive = false, 
  cardType 
}) => {
  const { searchResults } = useSearchResults();

  const handleClick = () => {
    if (isClickable && onClick) {
      onClick();
    }
  };

  return (
    <div 
      className={`stat-card ${isClickable ? 'clickable' : ''} ${isActive ? 'active' : ''} ${cardType ? `card-${cardType}` : ''}`}
      onClick={handleClick}
      style={{ cursor: isClickable ? 'pointer' : 'default' }}
    >
      <div className="stat-card-main">
        <h4 className="stat-title">{title}</h4>
        {value !== undefined && value !== null && value !== "" ? (
          <p className="stat-value">{value}</p>
        ) : (
          <div className="stat-placeholder">--</div>
        )}
        {/* {isClickable && (
          <div className="click-indicator">
            <span className="click-text">Click to filter</span>
          </div>
        )} */}
      </div>
      {isActive && <div className="active-indicator"></div>}
    </div>
  );
};

export default DetailCard;